import React from 'react';
import '../styles/PrivacyPolicy.css';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

function PrivacyPolicy() {
  const { language } = useLanguage();

  return (
    <div className="privacy-policy-page">
      <Helmet>
        <title>{language === 'he' ? 'מדיניות פרטיות | Invitly' : 'Privacy Policy | Invitly'}</title>
        <meta name="description" content={language === 'he' ? 'מדיניות הפרטיות של Invitly - כיצד אנו אוספים ומשתמשים בנתונים שלך.' : 'Invitly Privacy Policy - how we collect and use your data.'} />
        <link rel="canonical" href="https://invitly.org/privacy-policy" />
      </Helmet>
      <div className="privacy-policy-container">
        <style>{`
          [data-custom-class='body'], [data-custom-class='body'] * {
            background: transparent !important;
          }
          [data-custom-class='title'], [data-custom-class='title'] * {
            font-family: Arial !important;
            font-size: 26px !important;
            color: #000000 !important;
          }
          [data-custom-class='subtitle'], [data-custom-class='subtitle'] * {
            font-family: Arial !important;
            color: #595959 !important;
            font-size: 14px !important;
          }
          [data-custom-class='heading_1'], [data-custom-class='heading_1'] * {
            font-family: Arial !important;
            font-size: 19px !important;
            color: #000000 !important;
          }
          [data-custom-class='heading_2'], [data-custom-class='heading_2'] * {
            font-family: Arial !important;
            font-size: 17px !important;
            color: #000000 !important;
          }
          [data-custom-class='body_text'], [data-custom-class='body_text'] * {
            color: #595959 !important;
            font-size: 14px !important;
            font-family: Arial !important;
          }
          [data-custom-class='link'], [data-custom-class='link'] * {
            color: #3030F1 !important;
            font-size: 14px !important;
            font-family: Arial !important;
            word-break: break-word !important;
          }
          .privacy-policy-page ul {
            list-style-type: square;
          }
          .privacy-policy-page ul > li > ul {
            list-style-type: circle;
          }
          .privacy-policy-page ul > li > ul > li > ul {
            list-style-type: square;
          }
          .privacy-policy-page ol li {
            font-family: Arial;
          }
        `}</style>

        <div data-custom-class="body">
          <div>
            <strong>
              <span style={{ fontSize: '26px' }}>
                <span data-custom-class="title">
                  <h1>PRIVACY POLICY</h1>
                </span>
              </span>
            </strong>
          </div>
          <div>
            <span style={{ color: 'rgb(127, 127, 127)' }}>
              <strong>
                <span style={{ fontSize: '15px' }}>
                  <span data-custom-class="subtitle">Last updated April 13, 2026</span>
                </span>
              </strong>
            </span>
          </div>

          <div><br /></div><div><br /></div><div><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span data-custom-class="body_text">
                This Privacy Notice for <strong>Invitly</strong> ("
                <strong>we</strong>," "<strong>us</strong>," or "<strong>our</strong>"),
                describes how and why we might access, collect, store, use, and/or share ("
                <strong>process</strong>") your personal information when you use our services ("
                <strong>Services</strong>"), including when you:
              </span>
            </span>
          </div>

          <ul>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  Visit our website at{' '}
                  <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="https://invitly.org/">
                    https://invitly.org/
                  </a>{' '}
                  or any website of ours that links to this Privacy Notice
                </span>
              </span>
            </li>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  Engage with us in other related ways, including any marketing or events
                </span>
              </span>
            </li>
          </ul>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(127, 127, 127)' }}>
              <span data-custom-class="body_text">
                <strong>Questions or concerns?</strong> Reading this Privacy Notice will help you
                understand your privacy rights and choices. We are responsible for making decisions
                about how your personal information is processed. If you do not agree with our
                policies and practices, please do not use our Services. If you still have any
                questions or concerns, please contact us at{' '}
                <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="mailto:lea.benero@gmail.com">
                  lea.benero@gmail.com
                </a>.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SUMMARY */}
          <div style={{ lineHeight: '1.5' }}>
            <strong>
              <span style={{ fontSize: '15px' }}>
                <span data-custom-class="heading_1"><h2>SUMMARY OF KEY POINTS</h2></span>
              </span>
            </strong>
          </div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong><em>This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our </em></strong>
              </span>
            </span>
            <a data-custom-class="link" href="#toc">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text"><strong><em>table of contents</em></strong></span>
              </span>
            </a>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text"><strong><em> below to find the section you are looking for.</em></strong></span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>What personal information do we process?</strong> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. Learn more about{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#personalinfo">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text">personal information you disclose to us</span>
              </span>
            </a>
            <span data-custom-class="body_text">.</span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>Do we process any sensitive personal information?</strong> Some of the information may be considered "special" or "sensitive" in certain jurisdictions, for example your racial or ethnic origins, sexual orientation, and religious beliefs. We do not process sensitive personal information.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>Do we collect any information from third parties?</strong> We do not collect any information from third parties.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>How do we process your information?</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. Learn more about{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#infouse">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text">how we process your information</span>
              </span>
            </a>
            <span data-custom-class="body_text">.</span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>In what situations and with which parties do we share personal information?</strong> We may share information in specific situations and with specific third parties. Learn more about{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#whoshare">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text">when and with whom we share your personal information</span>
              </span>
            </a>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">.</span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>How do we keep your information safe?</strong> We have adequate organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Learn more about{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#infosafe">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text">how we keep your information safe</span>
              </span>
            </a>
            <span data-custom-class="body_text">.</span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>What are your rights?</strong> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. Learn more about{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#privacyrights">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text">your privacy rights</span>
              </span>
            </a>
            <span data-custom-class="body_text">.</span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>How do you exercise your rights?</strong> The easiest way to exercise your rights is by visiting{' '}
                <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="https://www.home.invitly.org/settings">
                  https://www.home.invitly.org/settings
                </a>, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">Want to learn more about what we do with any information we collect? </span>
            </span>
            <a data-custom-class="link" href="#toc">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>
                <span data-custom-class="body_text">Review the Privacy Notice in full</span>
              </span>
            </a>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">.</span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* TABLE OF CONTENTS */}
          <div id="toc" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>TABLE OF CONTENTS</h2></span>
            </strong>
          </div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#infocollect"><span style={{ color: 'rgb(0, 58, 250)' }}>1. WHAT INFORMATION DO WE COLLECT?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#infouse"><span style={{ color: 'rgb(0, 58, 250)' }}>2. HOW DO WE PROCESS YOUR INFORMATION?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#whoshare"><span style={{ color: 'rgb(0, 58, 250)' }}>3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><a data-custom-class="link" href="#ai"><span style={{ color: 'rgb(0, 58, 250)' }}>4. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?</span></a></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#inforetain"><span style={{ color: 'rgb(0, 58, 250)' }}>5. HOW LONG DO WE KEEP YOUR INFORMATION?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#infosafe"><span style={{ color: 'rgb(0, 58, 250)' }}>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#infominors"><span style={{ color: 'rgb(0, 58, 250)' }}>7. DO WE COLLECT INFORMATION FROM MINORS?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#privacyrights"><span style={{ color: 'rgb(0, 58, 250)' }}>8. WHAT ARE YOUR PRIVACY RIGHTS?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#DNT"><span style={{ color: 'rgb(0, 58, 250)' }}>9. CONTROLS FOR DO-NOT-TRACK FEATURES</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><span style={{ fontSize: '15px' }}><a data-custom-class="link" href="#policyupdates"><span style={{ color: 'rgb(0, 58, 250)' }}>10. DO WE MAKE UPDATES TO THIS NOTICE?</span></a></span></div>
          <div style={{ lineHeight: '1.5' }}><a data-custom-class="link" href="#contact"><span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></a></div>
          <div style={{ lineHeight: '1.5' }}><a data-custom-class="link" href="#request"><span style={{ color: 'rgb(0, 58, 250)' }}>12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span></a></div>

          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 1 */}
          <div id="infocollect" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>1. WHAT INFORMATION DO WE COLLECT?</h2></span>
            </strong>
            <span data-custom-class="heading_2" id="personalinfo">
              <span style={{ fontSize: '15px' }}>
                <strong><h3>Personal information you disclose to us</h3></strong>
              </span>
            </span>
            <span style={{ color: 'rgb(89, 89, 89)', fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short:</em></strong>
                <em> We collect personal information that you provide to us.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>Personal Information Provided by You.</strong> The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:
              </span>
            </span>
          </div>
          <ul>
            {['names', 'phone numbers', 'email addresses', 'usernames', 'passwords', 'details for an event', "user's provided contacts list"].map((item) => (
              <li key={item} data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
                <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                  <span data-custom-class="body_text">{item}</span>
                </span>
              </li>
            ))}
          </ul>

          <div id="sensitiveinfo" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                <strong>Sensitive Information.</strong> We do not process sensitive information.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 2 */}
          <div id="infouse" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>2. HOW DO WE PROCESS YOUR INFORMATION?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short: </em></strong>
                <em>We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</strong>
              </span>
            </span>
          </div>
          <ul>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  <strong>To facilitate account creation and authentication and otherwise manage user accounts.</strong> We may process your information so you can create and log in to your account, as well as keep your account in working order.
                </span>
              </span>
            </li>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  <strong>To deliver and facilitate delivery of services to the user.</strong> We may process your information to provide you with the requested service.
                </span>
              </span>
            </li>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  <strong>To respond to user inquiries/offer support to users.</strong> We may process your information to respond to your inquiries and solve any potential issues you might have with the requested service.
                </span>
              </span>
            </li>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
                <span data-custom-class="body_text">
                  <strong>To fulfill and manage your orders.</strong> We may process your information to fulfill and manage your orders, payments, returns, and exchanges made through the Services.
                </span>
              </span>
            </li>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px' }}>
                <span data-custom-class="body_text">
                  <strong>To post testimonials.</strong> We post testimonials on our Services that may contain personal information.
                </span>
              </span>
            </li>
          </ul>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 3 */}
          <div id="whoshare" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short:</em></strong>
                <em> We may share information in specific situations described in this section and/or with the following third parties.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">We may need to share your personal information in the following situations:</span>
            </span>
          </div>
          <ul>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px' }}>
                <span data-custom-class="body_text">
                  <strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
                </span>
              </span>
            </li>
          </ul>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 4 */}
          <div id="ai" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>4. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?</h2></span>
            </strong>
            <span style={{ fontSize: '15px' }}>
              <strong><em><span data-custom-class="body_text">In Short:</span></em></strong>
              <em><span data-custom-class="body_text"> We offer products, features, or tools powered by artificial intelligence, machine learning, or similar technologies.</span></em>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                As part of our Services, we offer products, features, or tools powered by artificial intelligence, machine learning, or similar technologies (collectively, "AI Products"). These tools are designed to enhance your experience and provide you with innovative solutions. The terms in this Privacy Notice govern your use of the AI Products within our Services.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}><strong><span data-custom-class="body_text">Use of AI Technologies</span></strong></span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                We provide the AI Products through third-party service providers ("AI Service Providers"), including <strong>OpenAI</strong>. As outlined in this Privacy Notice, your input, output, and personal information will be shared with and processed by these AI Service Providers to enable your use of our AI Products for purposes outlined in{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#whoshare">
              <span style={{ color: 'rgb(0, 58, 250)', fontSize: '15px' }}>WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span>
            </a>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text"> You must not use the AI Products in any way that violates the terms or policies of any AI Service Provider.</span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}><strong><span data-custom-class="body_text">Our AI Products</span></strong></span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}><span data-custom-class="body_text">Our AI Products are designed for the following functions:</span></span>
          </div>
          <ul>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span style={{ fontSize: '15px' }}><span data-custom-class="body_text">AI bots</span></span>
            </li>
          </ul>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}><strong><span data-custom-class="body_text">How We Process Your Data Using AI</span></strong></span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                All personal information processed using our AI Products is handled in line with our Privacy Notice and our agreement with third parties. This ensures high security and safeguards your personal information throughout the process, giving you peace of mind about your data's safety.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 5 */}
          <div id="inforetain" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>5. HOW LONG DO WE KEEP YOUR INFORMATION?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short: </em></strong>
                <em>We keep your information for as long as necessary to fulfill the purposes outlined in this Privacy Notice unless otherwise required by law.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements). No purpose in this notice will require us keeping your personal information for longer than the period of time in which users have an account with us.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 6 */}
          <div id="infosafe" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short: </em></strong>
                <em>We aim to protect your personal information through a system of organizational and technical security measures.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 7 */}
          <div id="infominors" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>7. DO WE COLLECT INFORMATION FROM MINORS?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short:</em></strong>
                <em> We do not knowingly collect data from or market to children under 18 years of age.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We do not knowingly collect, solicit data from, or market to children under 18 years of age, nor do we knowingly sell such personal information. By using the Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent's use of the Services. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18, please contact us at{' '}
                <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="mailto:lea.benero@gmail.com">
                  lea.benero@gmail.com
                </a>.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 8 */}
          <div id="privacyrights" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>8. WHAT ARE YOUR PRIVACY RIGHTS?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><em>In Short:</em></strong>
                <em> You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>

          <div id="withdrawconsent" style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <strong><u>Withdrawing your consent:</u></strong> If we are relying on your consent to process your personal information, which may be express and/or implied consent depending on the applicable law, you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section{' '}
              </span>
            </span>
            <a data-custom-class="link" href="#contact">
              <span style={{ fontSize: '15px', color: 'rgb(0, 58, 250)' }}>
                <span data-custom-class="body_text">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
              </span>
            </a>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text"> below.</span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                However, please note that this will not affect the lawfulness of the processing before its withdrawal nor, when applicable law allows, will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}>
            <span data-custom-class="heading_2"><strong><h3>Account Information</h3></strong></span>
            <span data-custom-class="body_text">
              <span style={{ fontSize: '15px' }}>If you would at any time like to review or change the information in your account or terminate your account, you can:</span>
            </span>
          </div>
          <ul>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span data-custom-class="body_text"><span style={{ fontSize: '15px' }}>Log in to your account settings and update your user account.</span></span>
            </li>
            <li data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <span data-custom-class="body_text"><span style={{ fontSize: '15px' }}>Contact us using the contact information provided.</span></span>
            </li>
          </ul>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">
                Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our legal terms and/or comply with applicable legal requirements.
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span data-custom-class="body_text">
              <span style={{ fontSize: '15px' }}>
                If you have questions or comments about your privacy rights, you may email us at{' '}
                <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="mailto:lea.benero@gmail.com">
                  lea.benero@gmail.com
                </a>.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 9 */}
          <div id="DNT" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>9. CONTROLS FOR DO-NOT-TRACK FEATURES</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage, no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Notice.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 10 */}
          <div id="policyupdates" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>10. DO WE MAKE UPDATES TO THIS NOTICE?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                <em><strong>In Short: </strong>Yes, we will update this notice as necessary to stay compliant with relevant laws.</em>
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                We may update this Privacy Notice from time to time. The updated version will be indicated by an updated "Revised" date at the top of this Privacy Notice. If we make material changes to this Privacy Notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this Privacy Notice frequently to be informed of how we are protecting your information.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 11 */}
          <div id="contact" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                If you have questions or comments about this notice, you may email us at{' '}
                <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="mailto:lea.benero@gmail.com">
                  lea.benero@gmail.com
                </a>{' '}
                or contact us by post at:
              </span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text"><strong>Invitly</strong></span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">Sokolov 17</span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">רעננה 4333417</span>
            </span>
          </div>
          <div style={{ lineHeight: '1.5' }}>
            <span style={{ fontSize: '15px' }}>
              <span data-custom-class="body_text">Israel</span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>

          {/* SECTION 12 */}
          <div id="request" style={{ lineHeight: '1.5' }}>
            <strong>
              <span data-custom-class="heading_1"><h2>12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</h2></span>
            </strong>
            <span style={{ fontSize: '15px', color: 'rgb(89, 89, 89)' }}>
              <span data-custom-class="body_text">
                Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. You may also have the right to withdraw your consent to our processing of your personal information. These rights may be limited in some circumstances by applicable law. To request to review, update, or delete your personal information, please visit:{' '}
                <a target="_blank" rel="noopener noreferrer" data-custom-class="link" href="https://www.home.invitly.org/settings">
                  https://www.home.invitly.org/settings
                </a>.
              </span>
            </span>
          </div>

          <div style={{ lineHeight: '1.5' }}><br /></div>
          <div>
            <span data-custom-class="body_text">This Privacy Policy was created using Termly's </span>
            <a href="https://termly.io/products/privacy-policy-generator/" target="_blank" rel="noopener noreferrer" data-custom-class="link">
              Privacy Policy Generator
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
